const DISMISS_PERIOD_DAYS = 21
const STORAGE_KEY_PREFIX = 'schema-mismatch-dismissed'

const getStorageKey = (productId: string, login: string): string => {
    return `${STORAGE_KEY_PREFIX}:${login}:${productId}`
}

const getDismissedTimestamp = (productId: string, login: string): number | null => {
    const key = getStorageKey(productId, login)
    const value = localStorage.getItem(key)
    if (!value) return null
    const timestamp = parseInt(value, 10)
    return isNaN(timestamp) ? null : timestamp
}

export const setDismissedTimestamp = (productId: string, login: string): void => {
    const key = getStorageKey(productId, login)
    localStorage.setItem(key, Date.now().toString())
}

export const removeDismissedTimestamp = (productId: string, login: string): void => {
    const key = getStorageKey(productId, login)
    localStorage.removeItem(key)
}

export const shouldShowNotification = (productId: string, login: string): boolean => {
    const lastDismissed = getDismissedTimestamp(productId, login)
    if (lastDismissed === null) return true

    const daysSinceDismissed = (Date.now() - lastDismissed) / (1000 * 60 * 60 * 24)
    return daysSinceDismissed >= DISMISS_PERIOD_DAYS
}